import React, { PureComponent, ReactNode } from 'react';
import { VenueRating } from 'js/model/rainbow/venue/VenueOutput';
import { choiceFormatter } from 'js/helpers/choice-formatter';
import { Inline, Text, Rating } from '@treatwell/ui';
import styles from './BrowseResultRating.module.css';

interface Props {
  reviewCountTemplate: string;
  rating: VenueRating;
  nowrap?: boolean;
}

export class BrowseResultRating extends PureComponent<Props> {
  private createRatingText(): string {
    return choiceFormatter(
      this.props.reviewCountTemplate,
      this.props.rating.count
    );
  }

  public render(): ReactNode {
    return (
      <Inline wrap={!this.props.nowrap} className={styles.rating}>
        {this.props.rating.count > 0 && (
          <Inline>
            <Rating
              rating={this.props.rating.displayAverage || '0.0'}
              size={16}
              showRatingValue
            />
          </Inline>
        )}
        <Text className={styles.label}>{this.createRatingText()}</Text>
      </Inline>
    );
  }
}
